import { makeAutoObservable } from 'mobx'
import { type IEntitiesStore } from 'entities/EntitiesExport'
import { type IIWorkFlowSendFromBlockArgs } from 'entities/Workflow'
import { SendFromStore } from 'widgets/SendFrom'
import { type ISendFromStoreProps } from 'widgets/SendFrom/store/SendFromStore'

export class SendFromBlockStore {
  sendFromStore: SendFromStore
  constructor(
    private _entities: IEntitiesStore,
    args?: IIWorkFlowSendFromBlockArgs | null,
    sendFromStoreProps?: ISendFromStoreProps
  ) {
    this.sendFromStore = new SendFromStore(this._entities, sendFromStoreProps)

    if (args) {
      this.sendFromStore.setSelectItem(
        {
          inbox_id: args.inboxId,
          number_id: args.sendingOptions?.number_id,
          smart_option: args.sendingOptions?.smart_option,
        },
        true
      )
    }
    makeAutoObservable(this)
  }

  get args(): IIWorkFlowSendFromBlockArgs {
    return {
      inboxId: this.sendFromStore.inbox_id || null,
      sendingOptions:
        this.sendFromStore.smart_option || this.sendFromStore.number_id
          ? {
              smart_option: this.sendFromStore.smart_option,
              number_id: this.sendFromStore.number_id,
            }
          : undefined,
    }
  }

  error = ''
  setError = (value: string) => {
    this.error = value
  }

  validate = () => {
    let isValid = true
    if (!this.args?.inboxId) {
      this.setError('Required field')
      isValid = false
    } else {
      this.setError('')
    }

    return isValid
  }
  reset = () => {
    this.sendFromStore.reset()
  }
}
